import { __extends } from "tslib";
import * as React from 'react';
import s from './preview-elements.scss';
import { PreviewMode } from '../preview-elements/preview-context';
import { Layout, Cell, AddItem, Text, Heading, Box } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
var PlansPreivewWrapper = /** @class */ (function (_super) {
    __extends(PlansPreivewWrapper, _super);
    function PlansPreivewWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickAddPlan = function (appId) {
            window.open("https://dev.wix.com/dc3/my-apps/" + appId + "/market/info/basic-info");
        };
        return _this;
    }
    PlansPreivewWrapper.prototype.render = function () {
        var _this = this;
        return (React.createElement(PreviewMode.Consumer, null, function (value) {
            return value.isPreview && _this.hasNoPlans() ? (React.createElement("div", null,
                React.createElement(Box, { direction: "vertical" },
                    React.createElement(Heading, { appearance: "H2" },
                        React.createElement(TranslatedKey, { tkey: 'solution.page.pricingAndPlans' })),
                    React.createElement(Text, null,
                        React.createElement(TranslatedKey, { tkey: 'solution.page.preview.pricingSubtitle' }))),
                React.createElement(Layout, null,
                    ' ',
                    React.createElement(Cell, { span: 6 },
                        React.createElement("div", { className: s.pricingCta },
                            React.createElement(AddItem, { onClick: function () { return _this.onClickAddPlan(value.appId); }, size: "large", theme: "filled" },
                                ' ',
                                React.createElement(TranslatedKey, { tkey: 'solution.page.preview.planCtaText' }))))))) : (_this.props.children);
        }));
    };
    PlansPreivewWrapper.prototype.hasNoPlans = function () {
        return !(this.props.plans !== undefined && this.props.plans.length > 0);
    };
    return PlansPreivewWrapper;
}(React.Component));
export { PlansPreivewWrapper };
var TranslatedKey = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, tkey = _a.tkey;
    return t(tkey);
});
//# sourceMappingURL=pricing-plan-wrapper.js.map